import { Pixall } from '../analytics/index.js';
/**
 * @summary Sends a Pixall event for the Filter click in the mobile toolbar
 * @events event156
 */
export function filterMobileToolbarClick(option, metadata) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    dataLayer = {},
    pixallData = {}
  } = metadata;
  pixallData.cdl = {
    eventProperties: {
      tagIndex: 'srp-002',
      element: 'Filters Menu',
      action: 'Click'
    }
  };
  Pixall.sendClickEvent({
    eventSource: 'filter',
    eventType: 'click',
    label: 'filter',
    hasListingType: false,
    ...pixallData
  }, dataLayer, option);
  return {};
}